var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isInit)?_c('div',[_c('div',{class:{ 'layout': _vm.withLayout, 'layout--is-ios-fullscreen': _vm.iosFullscreen}},[_c('router-view',{key:_vm.$router.currentRoute.fullPath})],1),_c('AppDialogContainer')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }